export const publishRequestPermission = {
    publishRequestSchedule: "publish-request.schedule",
    publishRequestsView: "publish-requests.view",
    publishRequestAccept: "publish-request.accept",
    publishRequestReject: "publish-request.reject",
    publishRequestStatusesView: "publish-request-statuses.view"
};
